import { assistantChatReportTypesEnum } from "helpers/enums";
import { buildQuery } from "helpers/reqparams";
import { alertRequest, body, request } from "services/request";

const resource = "api/assistantChat";
const PER_PAGE = 30;

const getSettings = () => request(`${resource}/getSettings`, { method: "GET" });
const applySettings = (params: {}) => alertRequest(`${resource}/applySettings`, body({ settings: params }));
const getMessages = (page: number) => {
    const query = { top: PER_PAGE, skip: PER_PAGE * page, orderBy: ["id desc"] };
    return request(`${resource}/getMessages${buildQuery(query)}`, { method: "GET" });
};
const getUnreadMessagesCount = () => request(`${resource}/getUnreadMessagesCount`, { method: "GET" });
const setMessagesAsRead = () => request(`${resource}/setMessagesAsRead`, body({}));
const downloadFile = (params: {}) => request(`${resource}/downloadFile`, params);
const getReport = (reportType: string, messageId: string) =>
    request(`${resource}/getReport/${reportType}/${messageId}`, { method: "GET" });

const getReportDisallowedUsers = (reportType: keyof typeof assistantChatReportTypesEnum) =>
    request(`${resource}/getReportDisallowedUsers/${reportType}`, { method: "GET" });
const applyReportDisallowedUsers = (params: {}) => alertRequest(`${resource}/applyReportDisallowedUsers`, body(params));

export {
    getSettings,
    applySettings,
    getMessages,
    getUnreadMessagesCount,
    setMessagesAsRead,
    downloadFile,
    getReport,
    PER_PAGE,
    getReportDisallowedUsers,
    applyReportDisallowedUsers,
};
